/**
 * @type {WindowProps}
 */
const WINDOW = new Map();

WINDOW.set("hidden", false);
WINDOW.set("width", null);
WINDOW.set("height", null);
WINDOW.set("document-width", null);
WINDOW.set("document-height", null);
WINDOW.set(
  "listeners",
  new Map([
    ["mutation", null],
    ["active", null],
    ["scroll", null],
    ["pointer", null],
    ["resize", null],
    ["visibilitychange", null],
  ])
);

WINDOW.set("observers", new Map());

WINDOW.set(
  "scroll",
  new Map([
    ["x", 0],
    ["y", 0],
    ["original-x", 0],
    ["original-y", 0],
    ["last-raf-x", 0],
    ["last-raf-y", 0],
    ["delta-y", 0],
    ["last-delta-y", 0],
  ])
);

WINDOW.set(
  "pointer",
  new Map([
    ["x", 0],
    ["y", 0],
    ["original-x", 0],
    ["original-y", 0],
    ["last-raf-x", 0],
    ["last-raf-y", 0],
  ])
);

WINDOW.set("now", null);
WINDOW.set("last-now", performance.now());
WINDOW.set("time-difference", 0);
WINDOW.set("time", 0);
WINDOW.set("raf", 0);
WINDOW.set("raf-last", 0);
WINDOW.set("raf-difference", 0);
WINDOW.set("raf-running", false);

WINDOW.set("resize", null);

WINDOW.set("async-variables-attempt", 0);

const script = /** @type {WindowScriptProps} */ (
  document.currentScript?.dataset
);

WINDOW.set("script", script || null);
WINDOW.set("env-dev", script?.torEnv === "dev");

const safari = /Safari/i.test(navigator.userAgent);
const chrome = /Chrome/i.test(navigator.userAgent);
const firefox = /Firefox/i.test(navigator.userAgent);

/** @type {boolean} */
const isChrome = !!(/** @type {any} */ (window).chrome);
const isFirefox = firefox;
const isSafari = safari && !chrome;

WINDOW.set("is-chrome", isChrome);
WINDOW.set("is-firefox", isFirefox);
WINDOW.set("is-safari", isSafari);

export const ENV_DEV = WINDOW.get("env-dev");

export default WINDOW;
